(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["da-calc"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var el=document.getElementById('daCalcBills'); if(!el) return;
    var out=document.getElementById('daCalcBillsOut'),mo=document.getElementById('daCalcMo'),yr=document.getElementById('daCalcYr'),you=document.getElementById('daCalcYou'),fee=document.getElementById('daCalcFee');
    var money=function(n){return '$'+Math.round(n).toLocaleString('en-US');};
    function update(){var bill=+el.value,rate=(+el.dataset.rate||22)/100,share=(+el.dataset.share||50)/100,save=bill*rate,keep=save*share,ours=save-keep;
      out.textContent=money(bill);mo.textContent=money(save);yr.textContent=money(save*12);you.textContent=money(keep);fee.textContent=money(ours);
      var pct=((bill-el.min)/(el.max-el.min))*100;el.style.background='linear-gradient(90deg,var(--accent) '+pct+'%, rgba(255,255,255,.10) '+pct+'%)';}
    el.addEventListener('input',update);update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["da-header"] && !Shopify.designMode) return;
  try {
    
  class DaHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.dah');
      this.burger = this.querySelector('.dah__burger');
      this.mobile = this.querySelector('.dah__mobile');
      const scroller = this.closest('.page-wrapper') || window;
      const onScroll = () => {
        const y = scroller === window ? window.scrollY : scroller.scrollTop;
        this.bar.classList.toggle('is-scrolled', y > 8);
      };
      scroller.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      this.burger.addEventListener('click', () => {
        const open = this.classList.toggle('is-open');
        this.burger.setAttribute('aria-expanded', open);
      });
      this.mobile.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
        this.classList.remove('is-open'); this.burger.setAttribute('aria-expanded', false);
      }));
    }
  }
  if (!customElements.get('da-header')) customElements.define('da-header', DaHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
